export default __webpack_public_path__ + "static/media/studentModalVideoCourse.1f1786f2.svg";